import * as React from 'react';
import { Portal } from '@fluentui/react-portal';
import { getSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of Tooltip
 */

export const renderTooltip_unstable = state => {
  const {
    slots,
    slotProps
  } = getSlots(state);
  return /*#__PURE__*/React.createElement(React.Fragment, null, state.children, state.shouldRenderTooltip && /*#__PURE__*/React.createElement(Portal, {
    mountNode: state.mountNode
  }, /*#__PURE__*/React.createElement(slots.content, { ...slotProps.content
  }, state.withArrow && /*#__PURE__*/React.createElement("div", {
    ref: state.arrowRef,
    className: state.arrowClassName
  }), state.content.children)));
};
//# sourceMappingURL=renderTooltip.js.map